// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  get(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("prescriptions/" + params.id + "/wedges")
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data.wedges);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  add(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.post("prescriptions/" + params.id + "/wedges", params.model)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },
  update(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.put(
        "prescriptions/" + params.prescriptionId + "/wedges/" + params.id,
        params.model
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },

  delete(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.delete(
        "prescriptions/" + params.prescriptionId + "/wedges/" + params.id
      )
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  quote(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put(
        "prescriptions/" +
          params.prescriptionId +
          "/wedges/" +
          params.id +
          "/quote",
        params
      )
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  }
};
